import React from 'react';
import '../../styles/onboardingFlow/mobileLogoCard/mobileLogoSlide3.scss';
import window1 from '../../assets/onboarding/slides/slide3/window1.svg';
import window2 from '../../assets/onboarding/slides/slide3/window2.svg';
import window3 from '../../assets/onboarding/slides/slide3/window3.svg';
import window4 from '../../assets/onboarding/slides/slide3/window4.svg';
import window5 from '../../assets/onboarding/slides/slide3/window5.svg';

const MobileLogoSlide3: React.FC = () => {
  return (
    <div className='mobileLogoSlide3'>
      <div className='mobileLogoSlide3__windows'>
        <div className='mobileLogoSlide3__window mobileLogoSlide3__window--1'>
          <img src={window1} alt='Optimization Window 1' />
        </div>
        <div className='mobileLogoSlide3__window mobileLogoSlide3__window--2'>
          <img src={window2} alt='Optimization Window 2' />
        </div>
        <div className='mobileLogoSlide3__window mobileLogoSlide3__window--3'>
          <img src={window3} alt='Optimization Window 3' />
        </div>
        <div className='mobileLogoSlide3__window mobileLogoSlide3__window--4'>
          <img src={window4} alt='Optimization Window 4' />
        </div>
        <div className='mobileLogoSlide3__window mobileLogoSlide3__window--5'>
          <img src={window5} alt='Optimization Window 5' />
        </div>
      </div>
    </div>
  );
};

export default MobileLogoSlide3;
